/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : Jul 27, 2025
Folder          : src/components/button
File            : ButtonCompDark.tsx
Description     : 
    This reusable component is a dark button.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/



// Pure validation function for capital letter check
export function textfieldErrors(newValue, setInputError, errorText, id, confirmPassword) {

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).+$/;

  switch (id) {
    case 'email':
      if (!newValue) {
        setInputError(true);
        errorText('Email is required.');
      } else if (!emailPattern.test(newValue)) {
        setInputError(true);
        errorText('Invalid email format.');
      } else {
        setInputError(false);
        errorText('');
      }
      return;
    case 'signin-email':
      // For sign-in, only check if field is not empty
      if (!newValue) {
        setInputError(true);
        errorText('Email is required.');
      } else {
        setInputError(false);
        errorText('');
      }
      return;
    case 'password':
      if (!newValue) {
        setInputError(true);
        errorText('Password is required.');
      } else if (newValue.length < 8) {
        setInputError(true);
        errorText('Password must be at least 8 characters long.');
      } else if (!passwordPattern.test(newValue)) {
        setInputError(true);
        errorText('Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.');
      } else {
        setInputError(false);
        errorText('');
        confirmPassword = newValue;
      }
      return;
    case 'signin-password':
      // For sign-in, only check if field is not empty
      if (!newValue) {
        setInputError(true);
        errorText('Password is required.');
      } else {
        setInputError(false);
        errorText('');
      }
      return;
    // case 'confirmPassword':
    //   if (!newValue) {
    //     setInputError(true);
    //     errorText('Confirm Password is required.');
    //   } else if (newValue !== confirmPassword) {
    //     setInputError(true);
    //     errorText('Passwords do not match.');
    //   } else {
    //     setInputError(false);
    //     errorText('');
    //   }
    //   return;
  }
}

